import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private storage: Storage
  ) {
    this.init();
  }


  async init() {
    await this.storage.create();
  }

  async setData(key: string, value: any): Promise<void> {
    await this.storage.set(key, value);
  }

  async getData<T = any>(key: string): Promise<T | null> {
    return this.storage.get(key);
  }

  async removeData(key: string): Promise<void> {
    await this.storage.remove(key);
  }

  async clearData(): Promise<void> {
    await this.storage.clear();
  }

  async getAllKeys(): Promise<string[]> {
    return this.storage.keys();
  }

  async getKeysAmount(): Promise<number> {
    return this.storage.length();
  }

  /** Kompletter Speicher-Dump als JSON-Download — für Debug- und Recovery-Zugänge. */
  async exportFullDumpAsJson(): Promise<void> {
    const keys = await this.getAllKeys();
    const dump: Record<string, any> = {};
    for (const key of keys) {
      dump[key] = await this.getData(key);
    }

    const blob = new Blob([JSON.stringify(dump, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `full-storage-dump-${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

}
